import { Input, InputLabel } from '@mui/material';
import { makeStyles } from '@mui/styles';
import * as React from 'react';
import { useEffect, useState } from 'react';

import { InputFieldProps } from '../../@types/Components';
import PlanModel from '../../models/standard/PlanModel';
import { usePlan } from '../../provider/PlanProvider';
import { immersightGrey } from '../../utils/colors';

// Create a Material UI styles object using makeStyles
const useStyles = makeStyles(() => ({
    // Define styles for the InputLabel
    inputLabel: {
        color: immersightGrey,
    },
    // Define styles for the Input
    input: {
    // Use a function to set the color based on the value
        color: ( value ) => value ? 'black' : immersightGrey,
        width: '100%',
    },
}));

const InputField = (props: InputFieldProps): JSX.Element => {
    const { id, placeholder, sx, onChange } = props;
    const {planModel, setPlanModel} = usePlan();

    // Use state to store the input value
    const [value, setValue] = useState(planModel.name);

    // Call the useStyles hook to get the classes object
    const classes = useStyles({ value });

    // Whenever the planModel gets changed, we set the value of the input field to its name property.
    useEffect(() => {
        if(value !== planModel.name) {
            setValue(planModel.name);
        }
    }, [planModel]);

    // Define a handleChange function to handle input changes
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    // Update the input value state
        setValue(event.target.value);
        // Call the onChange callback function if provided
        if (onChange) {
            onChange(event);
        }
    };

    // When enter gets pressed after input change, create a new plan model with the current value.
    const handleSubmit = (event: React.KeyboardEvent<HTMLInputElement>): void => {
        if(event.key === "Enter") {
            // FIX: Pass ALL existing properties to preserve them, only updating the name (value)
            setPlanModel((previousPlan) => new PlanModel(
                value, 
                previousPlan.id,
                previousPlan.kojeId,
                previousPlan.kojeLevel,
                previousPlan.eventId,
                previousPlan.dataObjectId,
                previousPlan.showroomId,
                previousPlan.appVersion,
                previousPlan.building,
                previousPlan.jsonVersion,
                previousPlan.region
            ));
        }
    };

    return (
        <>
            <InputLabel htmlFor={id} className={classes.inputLabel}/>
            <Input
                id={id}
                placeholder={placeholder}
                value={value}
                onChange={handleChange}
                disableUnderline
                className={classes.input}
                onKeyDown={handleSubmit}
                sx={sx}
            />
        </>
    );
}

export default InputField;
